import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
wrapper:{
  margin:'50px 0'
},
paginationCon:{
  margin: '20px 0',
  display:'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
}))
